import Spinner from 'components/feedback/Spinner';

const DeviationListSpinner = () => (
    <div
        className='display-flex h-90-percent align-items-center justify-content-center'
        data-testid='deviations-list-spinner'
    >
        <Spinner large borderWidth={8} size={200} />
    </div>
);

export default DeviationListSpinner;
